<template>
  <div class="dialog-app-panel" :class="linkDialog ? 'dialog-show' : ''">
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="linkDialog"
      :title="state === 1 ? '新增' : '修改'"
      @cancel="handleCancelPanel"
    >
      <el-form
        :model="configForm"
        ref="form"
        label-width="100px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="子系统" prop="subSystem">
              <el-select
                v-model="configForm.subSystem"
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in subSystemOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原始事件" prop="originalId">
              <el-select
                v-model="configForm.originalId"
                :disabled="
                  state == 2 && rowInfo.multiAlarmType == 1 ? true : false
                "
                placeholder="请选择"
              >
                <el-option
                  v-for="item in originalEventData"
                  :key="item.originalEventAlarmType"
                  :label="item.originalEventAlarmType"
                  :value="item.originalId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="两点报警" prop="multiAlarmType">
              <el-select
                v-model="configForm.multiAlarmType"
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in multiAlarmOption"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报警检测类型" prop="alarmDetectionType">
              <el-select
                v-model="configForm.alarmDetectionType"
                disabled
                placeholder="请选择"
              >
                <el-option
                  v-for="item in alarmDetectionOption"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="state == 1 || rowInfo.multiAlarmType == 2">
            <el-form-item label="报警距离" prop="alarmDistanceType">
              <el-select
                v-model="configForm.alarmDistanceType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in alarmDistanceOption"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="state == 1 || rowInfo.multiAlarmType == 2">
            <el-form-item label="报警间隔" prop="alarmInterval">
              <el-input
                v-model="configForm.alarmInterval"
                placeholder="请输入间隔时间，单位秒"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理方式" prop="processType">
              <el-select
                v-model="configForm.processType"
                placeholder="请选择"
                @change="chooseProcessType"
              >
                <el-option
                  v-for="item in processTypeData"
                  :key="item.ITEMKEY"
                  :label="item.ITEMVALUE"
                  :value="item.ITEMKEY"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="告警类型" prop="eventAlarmType">
              <el-select
                v-model="configForm.eventAlarmType"
                placeholder="请选择"
                @change="chooseAlarmType"
              >
                <el-option
                  v-for="item in eventAlarmTypeOption"
                  :key="item.eventAlarmId"
                  :label="item.itemValue"
                  :value="item.eventAlarmType"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="告警级别" prop="alarmLevel">
              <el-select v-model="configForm.alarmLevel" placeholder="请选择">
                <el-option
                  v-for="item in alarmLevelData"
                  :key="item.ITEMKEY"
                  :label="item.ITEMVALUE"
                  :value="item.ITEMKEY"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelPanel">取消</el-button>
        <el-button type="primary" @click="handleConfirmPanel">确认</el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../../api";
import { Dic, Bus, Dates } from "$utils";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    appPanel,
  },
  props: {
    state: {
      type: Number,
      default: 1,
    },
    originalEventData: {
      type: Array,
      default() {
        return [];
      },
    },
    processTypeData: {
      type: Array,
      default() {
        return [];
      },
    },
    alarmLevelData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      linkDialog: false,
      subSystemOptions: [
        {
          value: "4",
          label: "消防子系统",
        },
      ],
      multiAlarmOption: Dic.find("SENU100"),
      alarmDetectionOption: Dic.find("SENU101"),
      alarmDistanceOption: Dic.find("SENU102"),
      eventAlarmTypeOption: [],
      // 授权表单数据
      configForm: {
        // 子系统
        subSystem: "4",
        // 原始事件
        originalId: "",
        // 两点报警类型
        multiAlarmType: 2,
        // 报警检测类型
        alarmDetectionType: 2,
        // 报警距离类型
        alarmDistanceType: "",
        // 报警间隔
        alarmInterval: "",
        // 处理方式
        processType: "",
        // 告警类型
        eventAlarmType: "",
        // 安防事件码
        eventAlarmId: "",
        // 告警级别
        alarmLevel: "",
      },
      rules: {
        originalId: [
          {
            required: true,
            message: "请选择原始事件",
            trigger: "change",
          },
        ],
        alarmDistanceType: [
          {
            required: true,
            message: "请选择报警距离",
            trigger: "change",
          },
        ],
        alarmInterval: [
          {
            required: true,
            message: "请选择报警间隔",
            trigger: "blur",
          },
        ],
        processType: [
          {
            required: true,
            message: "请选择处理方式",
            trigger: "change",
          },
        ],
        eventAlarmType: [
          {
            required: true,
            message: "请选择告警类型",
            trigger: "change",
          },
        ],
        alarmLevel: [
          {
            required: true,
            message: "请选择告警级别",
            trigger: "change",
          },
        ],
      },
      rowInfo: {},
    };
  },
  watch: {},
  mounted() {},
  methods: {
    open(item) {
      this.linkDialog = true;
      // 修改的时候需要回填 因为告警类型是根据子系统及处理方式获得的，所以需要调用接口去查对应的告警类型数组数据
      if (this.state === 2) {
        this.rowInfo = item;
        this.getQueryTypeOptions(this.configForm.subSystem, item.processType);
        this.configForm = {
          // 子系统
          subSystem: "4",
          // 原始事件
          originalId: Number(item.originalId),
          // 两点报警类型
          multiAlarmType: Number(item.multiAlarmType),
          // 报警检测类型
          alarmDetectionType: Number(item.alarmDetectionType),
          // 报警距离类型
          alarmDistanceType: Number(item.alarmDistanceType),
          // 报警间隔
          alarmInterval: item.alarmInterval,
          // 处理方式
          processType: item.processType,
          // 告警类型
          eventAlarmType: item.eventAlarmType,
          // 安防事件码
          eventAlarmId: item.eventAlarmId,
          // 告警级别
          alarmLevel: item.alarmLevel,
        };
      }
    },
    chooseProcessType(value) {
      this.configForm.processType = value;
      this.getQueryTypeOptions(this.configForm.subSystem, value);
    },
    // 获取查询条件中的告警类型下拉
    getQueryTypeOptions(subValue, typeValue) {
      const params = {
        subSystem: subValue,
        processType: typeValue,
      };
      if (this.configForm.subSystem) {
        this.$fetch(api.device.vcnConfigureDeviceEunmInfo, params).then(
          (res) => {
            this.eventAlarmTypeOption = res.returnObj;
          }
        );
        // console.log('---day888888a----', this.eventAlarmTypeOption);
      } else {
        this.eventAlarmTypeOption = [];
      }
    },
    chooseAlarmType(value) {
      this.getEventAlarmIdByEventAlarmType(value);
    },
    // 根据当前选择的告警类型eventAlarmType获取对应的安防事件码eventAlarmId
    getEventAlarmIdByEventAlarmType(value) {
      this.eventAlarmTypeOption.forEach((item, index) => {
        if (item.eventAlarmType === value) {
          this.configForm.eventAlarmId = item.eventAlarmId;
        }
      });
    },
    // 确认弹框
    handleConfirmPanel() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let url =
            this.state === 1
              ? api.fire.addAlarmEventRule
              : api.fire.updateAlarmEventRule;
          let params = {};
          if (this.state === 1) {
            params = this.configForm;
          } else {
            params = {
              // 子系统
              subSystem: "4",
              // 原始事件
              originalId: this.configForm.originalId,
              // 两点报警类型
              multiAlarmType: this.configForm.multiAlarmType,
              // 报警检测类型
              alarmDetectionType: this.configForm.alarmDetectionType,
              // 报警距离类型
              alarmDistanceType: this.configForm.alarmDistanceType,
              // 报警间隔
              alarmInterval: this.configForm.alarmInterval,
              // 处理方式
              processType: this.configForm.processType,
              // 告警类型
              eventAlarmType: this.configForm.eventAlarmType,
              // 安防事件码
              eventAlarmId: this.configForm.eventAlarmId,
              // 告警级别
              alarmLevel: this.configForm.alarmLevel,
              ruleId: this.rowInfo.ruleId,
            };
          }
          // console.log('===消防事件参数====', params);
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.handleCancelPanel();
              this.$emit("refresh");
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    // 取消弹框
    handleCancelPanel() {
      this.$refs["form"].resetFields();
      this.configForm = {
        // 子系统
        subSystem: "4",
        // 原始事件
        originalId: "",
        // 两点报警类型
        multiAlarmType: 2,
        // 报警检测类型
        alarmDetectionType: 2,
        // 报警距离类型
        alarmDistanceType: "",
        // 报警间隔
        alarmInterval: "",
        // 处理方式
        processType: "",
        // 告警类型
        eventAlarmType: "",
        // 安防事件码
        eventAlarmId: "",
        // 告警级别
        alarmLevel: "",
      };
      this.linkDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.choose-box {
  .el-dialog__body {
    .el-input__inner {
      width: 215px;
    }
  }
}
</style>
